import { createAction, props } from '@ngrx/store'
import { Designation } from './designation.state'

// Action to load Designation
export const loadDesignations = createAction(
  '[Designation] Load Designations',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful Designation load
export const loadDesignationsSuccess = createAction(
  '[Designation] Load Designation Success',
  props<{
    totalCount: number
    designations: Designation[]
    totalDepartments: number
  }>()
)

// Action for Designation load failure
export const loadDesignationsFailure = createAction(
  '[Designation] Load Designation Failure',
  props<{ error: string }>()
)

export const loadDesignationCounts = createAction('[Designation] Load Counts')
export const setDesignationCounts = createAction(
  '[Designation] Set Counts',
  props<{ totalCount: number }>()
)

export const createDesignation = createAction(
  '[Designation] Create Designation',
  props<{
    designationName: string
    departmentId: string
    businessId: string
  }>()
)

export const createDesignationSuccess = createAction(
  '[Designation] Create Designation Success',
  props<{ designation: Designation }>()
)

export const createDesignationFailure = createAction(
  '[Designation] Create Designation Failure',
  props<{ error: any }>()
)

export const updateDesignation = createAction(
  '[Designation] Update Designation',
  props<{
    id: string
    designationName: string
    departmentId: string
    businessId: string
  }>()
)

export const updateDesignationSuccess = createAction(
  '[Designation] Update Designation Success',
  props<{ designation: Designation }>()
)

export const updateDesignationFailure = createAction(
  '[Designation] Update Designation Failure',
  props<{ error: any }>()
)

export const blockDesignation = createAction(
  '[Designation] Block Designation',
  props<{ id: string; disabled: boolean }>()
)

export const blockDesignationSuccess = createAction(
  '[Designation] Block Designation Success',
  props<{ designation: Designation }>()
)

export const blockDesignationFailure = createAction(
  '[Designation] Block Designation Failure',
  props<{ error: string }>()
)

export const deleteDesignation = createAction(
  '[Designation] Delete Designation',
  props<{ id: string }>()
)

export const deleteDesignationSuccess = createAction(
  '[Designation] Delete Designation Success',
  props<{ id: string }>()
)

export const deleteDesignationFailure = createAction(
  '[Designation] Delete Designation Failure',
  props<{ error: any }>()
)

export const resetDesignationState = createAction('[Designation] Reset State')
